import audioImage from '../../images/gallerium/onDemand/audio-pdf-thumbnail.png'
import posterImage from '../../images/gallerium/onDemand/pdf-thumbnail.png'
import videoImage from '../../images/gallerium/onDemand/video-thumbnail.png'

import {
  mte1Videos,
  mte2Videos,
  onDemandVideosType,
  satelliteVideos,
  shortTalkVideos,
} from './videos'


export interface onDemandCategoryType {
  id: string
  categoryName: string
  thumbnail: string
  destination: string
  videos?: Array<onDemandVideosType>
}
const MTECategories: Array<onDemandCategoryType> = [
  {
    id: 'mte1',
    categoryName: 'MTE Day 1',
    thumbnail: videoImage,
    destination: '/on-demand/mte-day-one',
    videos: mte1Videos,
  },
  {
    id: 'mte2',
    categoryName: 'MTE Day 2',
    thumbnail: videoImage,
    destination: '/on-demand/mte-day-two',
    videos: mte2Videos,
  },
]

const onDemandCategories: Array<onDemandCategoryType> = [
  {
    id: 'cat1',
    categoryName: 'Satellite On Demand',
    thumbnail: videoImage,
    destination: '/on-demand/satellite',
    videos: satelliteVideos,
  },
  {
    id: 'cat2',
    categoryName: 'Short Talk',
    thumbnail: videoImage,
    destination: '/on-demand/short-talk',
    videos: shortTalkVideos,
  },
]
const posterCategories: Array<onDemandCategoryType> = [
  {
    id: 'fol1',
    categoryName: 'Best 17 Abstracts in Research (Clinical)',
    thumbnail: audioImage,
    destination: '/on-demand/best-17-clinical',
  },
  {
    id: 'fol2',
    categoryName: 'Best 15 Abstracts in Research (Laboratory)',
    thumbnail: audioImage,
    destination: '/on-demand/best-15-laboratory',
  },
  {
    id: 'fol3',
    categoryName: 'Clinical Research',
    thumbnail: audioImage,
    destination: '/on-demand/clinical',
  },
  {
    id: 'fol4',
    categoryName: 'Laboratory Research',
    thumbnail: audioImage,
    destination: '/on-demand/laboratory',
  },
  {
    id: 'fol5',
    categoryName: 'Case Report / Case Series Clinical',
    thumbnail: posterImage,
    destination: '/on-demand/case-clinical',
  },
  {
    id: 'fol6',
    categoryName: 'Case Report / Case Series Laboratory',
    thumbnail: posterImage,
    destination: '/on-demand/case-laboratory',
  },
]

export { onDemandCategories, posterCategories, MTECategories }
